import { render } from "./LoyaltyTable.vue?vue&type=template&id=6bae7bfc&scoped=true"
import script from "./LoyaltyTable.vue?vue&type=script&lang=js"
export * from "./LoyaltyTable.vue?vue&type=script&lang=js"

import "./LoyaltyTable.vue?vue&type=style&index=0&id=6bae7bfc&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bae7bfc"]])

export default __exports__